export default function Logo({ onDark = false }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="brand-logo">
      <svg viewBox="0 0 64 64" className="h-10 w-10 shrink-0" aria-hidden="true">
        <rect width="64" height="64" rx="14" fill="#065F46" />
        <circle cx="32" cy="34" r="19" fill="none" stroke="#F59E0B" strokeWidth="3" />
        <circle cx="24" cy="28" r="3.4" fill="#FFFBEB" />
        <circle cx="32" cy="24" r="3.4" fill="#FFFBEB" />
        <circle cx="40" cy="28" r="3.4" fill="#FFFBEB" />
        <path d="M20 40c4 5 8 7 12 7s8-2 12-7" fill="none" stroke="#FFFBEB" strokeWidth="3" strokeLinecap="round" />
        <path d="M8 12h20M4 18h16" stroke="#F59E0B" strokeWidth="3" strokeLinecap="round" />
      </svg>
      <div className="leading-tight">
        <p className={`font-display text-lg font-bold tracking-tight ${onDark ? "text-amber-50" : "text-emerald-950"}`}>
          Jain Food <span className="italic text-amber-600">on</span> Train
        </p>
        <p className={`text-[10px] font-semibold uppercase tracking-[0.22em] ${onDark ? "text-amber-200/70" : "text-emerald-800/70"}`}>
          Satvik • Shudh • On time
        </p>
      </div>
    </div>
  );
}
